/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 问答板块
const RecommendedQuestion = resolve =>
  require(['../../../views/RecommendedQuestion'], resolve)
const SearchQuestion = resolve =>
  require(['../../../views/SearchQuestion'], resolve)
const IndexQuestion = resolve =>
  require(['../../../views/question/IndexQuestion'], resolve)
const MyQuestion = resolve =>
  require(['../../../views/question/MyQuestion'], resolve)
const OpenReward = resolve =>
  require(['../../../views/question/OpenReward'], resolve)
const BindZFb = resolve => require(['../../../views/question/bindZFb'], resolve)

export default [
  // 问答板块
  {
    path: '/recommended-question',
    component: RecommendedQuestion
  },
  {
    path: '/search-question',
    component: SearchQuestion
  },
  {
    path: '/index-question',
    component: IndexQuestion
  },
  {
    path: '/my-question',
    component: MyQuestion
  },
  {
    path: '/open-reward',
    component: OpenReward,
    name: 'OpenReward'
    // 开通打赏
  },
  {
    path: '/bindZFb',
    component: BindZFb,
    name: 'BindZFb'
    // 开通打赏
  }
]



// WEBPACK FOOTER //
// ./src/router/page/question/index.js